// ES6 module imports
import 'bootstrap';
import 'paroller.js';
import 'flexslider';
import 'bootstrap-datepicker';
import 'bootstrap-select';
import 'bootstrap-touchspin';
import 'magnific-popup';

/*
import '@claviska/jquery-animate-css';
import 'animate.css';
import 'animejs';
import 'awesome-bootstrap-checkbox';
import 'is-in-viewport';
import 'javascript-flex-images';
import 'matchmedia-polyfill';
import 'object-fit-images';
*/

// Plugin imports
import 'sticky-kit/dist/sticky-kit.js';
import 'jquery-textfill/source/jquery.textfill.js';
import 'jquery-touchswipe/jquery.touchSwipe.js';
import 'animatecss.js/dist/jquery.animatecss.js';
import '../js/scripts.js';


// CSS imports
import 'bootstrap/dist/css/bootstrap.css';
import 'awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css';
import 'animate.css/animate.css';
import 'flexslider/flexslider.css';
import 'magnific-popup/dist/magnific-popup.css';
import 'bootstrap-select/dist/css/bootstrap-select.css';
import 'bootstrap-touchspin/dist/jquery.bootstrap-touchspin.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import 'simple-line-icons/css/simple-line-icons.css';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/brands.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/v4-shims.css';

//import '../less/styles.less';

$(function() {
  console.log('grtemplate loaded with Bootstrap');
});
